export default __webpack_public_path__ + "static/media/flag-nl.5448bdcc.svg";